import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import procenaRizikaImg from "../../../../../picture/sredstva-oprema.png";
import ElektroOpremaPocetna from "./ElektroOpremaPocetna";

const obrazci = [
  "ЛИЧНА ЗАШТИТНА ОПРЕМА",
  "МАШИНЕ И УРЕЂАЈИ",
  "ПРЕВОЗНА СРЕДСТВА И МЕХАНИЗАЦИЈА",
  "ЕЛЕКТРО ОПРЕМА И ИНСТАЛАЦИЈЕ",
  "КОЛЕКТИВНА ОПРЕМА",
  "СРЕДСТВА ЗА ПРУЖАЊЕ ПРВЕ ПОМОЋИ",
  "ОСТАЛА СРЕДСТВА И ОПРЕМА ЗА РАД",
  "ПРОЦЕСНИ МАТЕРИЈАЛИ",
];

function ShowBarElektroOprema() {
  const { selectedSredstvaOprema, setSelectedSredstvaOprema } =
    useGlobalContext();

  const handleClickObrazac = (index) => {
    if (selectedSredstvaOprema !== index + 1) {
      setSelectedSredstvaOprema(index + 1);
    } else {
      setSelectedSredstvaOprema(0);
    }
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: "10px",
        }}
      >
        <img src={procenaRizikaImg} style={{ width: "40%" }} />
      </div>

      {selectedSredstvaOprema === 2 ? (
        <ElektroOpremaPocetna />
      ) : (
        <div style={{ height: "500px", overflowY: "auto" }}>
          {obrazci.map((obrazac, i) => (
            <div onClick={() => handleClickObrazac(i)} key={i}>
              <Button
                active={selectedSredstvaOprema === i + 1}
                style={{
                  padding: "7px",
                  fontWeight: "bold",
                  textAlign: "left",
                  minHeight: "64px",
                  display: "block",
                  fontSize: "16px",
                }}
              >
                {obrazac}
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ShowBarElektroOprema;